import { render, staticRenderFns } from "./MarketingEmailEditContent.vue?vue&type=template&id=cc2e1ff6&scoped=true"
import script from "./MarketingEmailEditContent.vue?vue&type=script&lang=js"
export * from "./MarketingEmailEditContent.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailEditContent.vue?vue&type=style&index=0&id=cc2e1ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2e1ff6",
  null
  
)

export default component.exports